import * as action_types from '../../config/constants/application-actions';

const application_default = {
    application: {
        appInfo: {},
        appConfig: {},
        contextVariables: {},
        buckets: {}
    }
};

const applicationReducer = (state = application_default, action = {}) => {
    switch (action.type) {
        case action_types.set_application:
            return {
                application: {
                    ...state.application,
                    appInfo: action.payload
                }
            };
        case action_types.set_configuration:
            return {
                application: {
                    ...state.application,
                    appConfig: action.payload
                }
            };
        case action_types.set_context_variables:
            return {
                application: {
                    ...state.application,
                    contextVariables: {
                        [action.payload.contactIdentity]:
                            action.payload.variables
                    }
                }
            };
        case action_types.set_bucket_document:
            return {
                application: {
                    ...state.application,
                    buckets: {
                        ...state.application.buckets,
                        [action.payload.bucketId]: action.payload.resource
                    }
                }
            };
        default:
            return state;
    }
};

export { application_default };
export default applicationReducer;
